import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const listProfiles = () => api.get("/profiles").then((r) => r.data);
export const createProfile = (data) => api.post("/profiles", data).then((r) => r.data);
export const getProfile = (id) => api.get(`/profiles/${id}`).then((r) => r.data);
export const deleteProfile = (id) => api.delete(`/profiles/${id}`).then((r) => r.data);
export const updateProgress = (id, category, item_key) =>
  api.post(`/profiles/${id}/progress`, { category, item_key }).then((r) => r.data);
export const setLevel = (id, category, level) =>
  api.post(`/profiles/${id}/level`, { category, level }).then((r) => r.data);
export const setMode = (id, big_kids) =>
  api.post(`/profiles/${id}/mode`, { big_kids }).then((r) => r.data);
export const checkin = (id) =>
  api.post(`/profiles/${id}/checkin`).then((r) => r.data);
export const createCheckout = (lookup_key, user_id) =>
  api.post("/payments/checkout", { lookup_key, user_id, origin_url: window.location.origin }).then((r) => r.data);
export const getPaymentStatus = (session_id) =>
  api.get(`/payments/status/${session_id}`).then((r) => r.data);
export const fetchTTS = (text, voice = "nova") =>
  api.post("/tts", { text, voice }).then((r) => r.data);
